import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import HotelSummary from './HotelSummary';
import HotelStay from './HotelStay';

export default function HotelConfirmation() {
  return (
    <ConfirmationPage
      module="hotels"
      Summary={HotelSummary}
      refLabel="Hotel confirmation no."
      Extra={HotelStay}
      nextSteps={[
        'Your hotel voucher has been emailed — show it at the front desk.',
        'Carry a valid government photo ID for every guest.',
        'Some hotels collect local fees or a security deposit at check-in; see the hotel page.',
        'View or cancel your booking anytime from My Trips.',
      ]}
    />
  );
}
